import { TDeviceType } from '@cian/ui-kit';

import { getExtendedRegion } from 'shared/common/packages/Filters/shared/containers/filters/GeoContainer/helpers';
import { getAppliedModifiers } from 'shared/map-search/containers/DesktopFiltersMicrofrontend/utils';
import { GEO_CHANGE_ACTIONS } from 'shared/map-search/containers/FiltersContainer/constants';
import { trackApplyClick, trackPageView } from 'shared/map-search/containers/FiltersContainer/tracking';
import { IFiltersUpdatedEventDetail } from 'shared/map-search/types/microfrontends';
import { TThunkAction } from 'shared/map-search/types/redux';
import { produceGeoChangeEvent } from 'shared/map-search/utils/events';

import { changeJsonQuery, fetchTags } from '../filters';
import { fetchNewbuildingPromoPins } from '../newbuildingPromoFeatures';
import { fetchClusters } from '../results';

interface IParams {
  isAwaitingGeoUpdate: React.MutableRefObject<boolean>;
  deviceType: TDeviceType;
  detail: IFiltersUpdatedEventDetail;
}

export function makeSearch({ isAwaitingGeoUpdate, deviceType, detail }: IParams): TThunkAction<Promise<void>> {
  return async (dispatch, getState) => {
    const {
      user,
      regionId,
      queryString,
      results: { jsonQuery },
    } = getState();

    const {
      jsonQuery: { region },
    } = detail;

    dispatch(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      changeJsonQuery({ appliedModifiers: [] as any, prevJsonQuery: jsonQuery, nextJsonQuery: detail.jsonQuery }),
    );

    const appliedModifiers = getAppliedModifiers({ prevJsonQuery: jsonQuery, nextJsonQuery: detail.jsonQuery });

    if (appliedModifiers.some(modifier => GEO_CHANGE_ACTIONS.includes(modifier.action))) {
      isAwaitingGeoUpdate.current = true;

      trackPageView({
        jsonQuery: detail.jsonQuery,
        user,
        deviceType,
        regionId,
      });

      if (region) {
        produceGeoChangeEvent([{ action: 'setRegion', arguments: [getExtendedRegion(region.value[0])] }]);
      }
    }

    dispatch(fetchTags());
    dispatch(fetchClusters({ updateBounds: isAwaitingGeoUpdate.current, deviceType }));
    dispatch(fetchNewbuildingPromoPins());
    isAwaitingGeoUpdate.current = false;

    trackPageView({ jsonQuery: detail.jsonQuery, user, deviceType, regionId });
    trackApplyClick({ jsonQuery: detail.jsonQuery, queryString });
  };
}
